import React, { useEffect, useState } from "react";

export const AdvertenciaSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);

  return (
    <select
      className="select-advertencia"
      name={name} 
      value={value}
      onChange={onChange}
    >
      <option value="C">Consolidado</option>
      <option value="S">Si</option>
      <option value="N">No</option>
      {state.map((item) => (
        <option key={`linea-${item.value}`} value={item.value}>
          {item.linea}
        </option>
      ))}
    </select>
  );
};